<template>
  <div>
    <v-data-table :headers="headers">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search Keyword"
            single-line
            hide-details
            class="shrink mx-4"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-dialog
            v-model="dialogEdit"
            max-width="80%"
            v-if="roles.list_crawled_products"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                v-if="roles.list_crawled_products"
                >Add Keyword</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" v-if="informText != ''">
                      <v-alert type="error">
                        {{ informText }}
                      </v-alert>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model="editedItem.tag_name"
                        label="Keyword"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model="editedItem.tag_name"
                        label="Product Type"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.tag_name"
                        label="Variants"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.tag_name"
                        label="Tags"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-switch label="Enable"></v-switch>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="check">Check</v-btn> -->
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                  v-if="showBtn == true && roles.update_tag"
                  >Save</v-btn
                >
                <v-btn color="blue darken-1" text v-else disabled>Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn color="primary" class="mb-2" v-else disabled
            >Add Keyword</v-btn
          >
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
//import axios from "axios";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "AutoCrawlList",

  components: {},

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  data: () => ({
    dialogEdit: false,

    roles: [],
    listKeywords: [],

    search: null,
    loading: false,
    headers: [
      { text: "Keyword", value: "Keyword" },
      { text: "Product Type", value: "Keyword" },
      { text: "Variants", value: "Keyword" },
      { text: "Tags", value: "Keyword" },
      { text: "Last Run", value: "Keyword" },
      { text: "Status", value: "Keyword" },
      { text: "Actions", value: "Keyword" },
    ],
    showBtn: false,

    editedItem: {
      tagName: "",
    },

    defaultItem: {
      tagName: "",
    },

    informText: "",
  }),

  methods: {
    loadData() {},

    close() {
      this.dialogEdit = false;
    },

    validation() {},
  },

  async mounted() {
    this.roles = await this.$cookies.get("crawled_product");
    if (this.roles.list_crawled_products) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    console.log("roles: ", this.roles);

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      //console.log(this.roles);
      var currentSession;
      try {
        currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
        console.log("auto-crawl-mounted currentSession: ", currentSession);
      } catch (error) {
        console.log("auto-crawl-mounted error: ", error);
      }

      if (currentSession != undefined) {
        this.loadData();
      }
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>